import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=b45a971e&scoped=true&"
import script from "@/scripts/Identity/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Identity/index.js?vue&type=script&lang=js&"
import style0 from "./Identity.vue?vue&type=style&index=0&id=b45a971e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a971e",
  null
  
)

export default component.exports